/**
 * Modal Utilities - SkidSteerCabs Custom Theme
 * Reusable modal functions for consistent UX across the site
 */

window.ModalUtils = (function() {
  
  // Show a modal with custom options
  function showModal(modalId, options = {}) {
    const modal = document.getElementById(modalId + '-overlay');
    if (!modal) {
      console.error('Modal not found:', modalId);
      return;
    }
    
    // Update modal content if provided
    if (options.title) {
      const titleElement = modal.querySelector('.modal-title');
      if (titleElement) titleElement.textContent = options.title;
    }
    
    if (options.content) {
      const contentElement = modal.querySelector('.modal-text');
      if (contentElement) contentElement.textContent = options.content;
    }
    
    if (options.confirmText) {
      const confirmButton = modal.querySelector('.modal-confirm');
      if (confirmButton) confirmButton.textContent = options.confirmText;
    }
    
    if (options.cancelText) {
      const cancelButton = modal.querySelector('.modal-cancel');
      if (cancelButton) cancelButton.textContent = options.cancelText;
    }
    
    // Set up confirm callback
    if (options.onConfirm && window.modalCallbacks && window.modalCallbacks[modalId]) {
      window.modalCallbacks[modalId].confirm = options.onConfirm;
    }
    
    // Show modal
    modal.classList.add('show');
    document.body.classList.add('modal-open');
    
    // Focus first button for accessibility
    const firstButton = modal.querySelector('.modal-footer .btn');
    if (firstButton) {
      setTimeout(() => firstButton.focus(), 100);
    }
  }
  
  // Hide a modal
  function hideModal(modalId) {
    const modal = document.getElementById(modalId + '-overlay');
    if (!modal) return;
    
    modal.classList.remove('show');
    document.body.classList.remove('modal-open');
  }
  
  // Show a confirmation modal (returns a promise)
  function confirm(options = {}) {
    return new Promise((resolve) => {
      const modalId = 'confirm-modal';
      
      // Create modal if it doesn't exist
      if (!document.getElementById(modalId + '-overlay')) {
        createConfirmModal();
      }
      
      const defaultOptions = {
        title: 'Confirm Action',
        content: 'Are you sure you want to continue?',
        confirmText: 'Confirm',
        cancelText: 'Cancel',
        onConfirm: () => resolve(true)
      };
      
      const mergedOptions = { ...defaultOptions, ...options };
      
      // Override onConfirm to resolve promise
      mergedOptions.onConfirm = () => resolve(true);
      
      // Set up cancel callback
      if (window.modalCallbacks && window.modalCallbacks[modalId]) {
        const originalClose = window.modalCallbacks[modalId].close;
        window.modalCallbacks[modalId].close = () => {
          resolve(false);
          originalClose();
        };
      }
      
      showModal(modalId, mergedOptions);
    });
  }
  
  // Create a default confirmation modal
  function createConfirmModal() {
    const modalHTML = `
      <div class="modal-overlay" id="confirm-modal-overlay" data-modal="confirm-modal">
        <div class="modal-container modal-medium">
          <div class="modal-content">
            <div class="modal-header">
              <h3 class="modal-title">Confirm Action</h3>
              <button type="button" class="modal-close" data-modal-close="confirm-modal" aria-label="Close modal">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
            </div>
            <div class="modal-body">
              <p class="modal-text">Are you sure you want to continue?</p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn--outline modal-cancel" data-modal-close="confirm-modal">
                Cancel
              </button>
              <button type="button" class="btn btn--primary modal-confirm" data-modal-confirm="confirm-modal">
                Confirm
              </button>
            </div>
          </div>
        </div>
      </div>
    `;
    
    document.body.insertAdjacentHTML('beforeend', modalHTML);
    
    // Initialize modal functionality
    initializeModal('confirm-modal');
  }
  
  // Initialize modal functionality
  function initializeModal(modalId) {
    const modalOverlay = document.getElementById(modalId + '-overlay');
    const closeButtons = modalOverlay.querySelectorAll(`[data-modal-close="${modalId}"]`);
    const confirmButton = modalOverlay.querySelector(`[data-modal-confirm="${modalId}"]`);
    
    function closeModal() {
      modalOverlay.classList.remove('show');
      document.body.classList.remove('modal-open');
    }
    
    closeButtons.forEach(btn => {
      btn.addEventListener('click', closeModal);
    });
    
    modalOverlay.addEventListener('click', function(e) {
      if (e.target === modalOverlay) {
        closeModal();
      }
    });
    
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modalOverlay.classList.contains('show')) {
        closeModal();
      }
    });
    
    window.modalCallbacks = window.modalCallbacks || {};
    window.modalCallbacks[modalId] = {
      confirm: null,
      close: closeModal
    };
    
    if (confirmButton) {
      confirmButton.addEventListener('click', function() {
        if (window.modalCallbacks[modalId].confirm) {
          window.modalCallbacks[modalId].confirm();
        }
        closeModal();
      });
    }
  }
  
  // Public API
  return {
    show: showModal,
    hide: hideModal,
    confirm: confirm
  };
})();
